import { render, staticRenderFns } from "./followRecordList.vue?vue&type=template&id=1ecd578d&scoped=true&"
import script from "./followRecordList.vue?vue&type=script&lang=js&"
export * from "./followRecordList.vue?vue&type=script&lang=js&"
import style0 from "./followRecordList.vue?vue&type=style&index=0&id=1ecd578d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd578d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ecd578d')) {
      api.createRecord('1ecd578d', component.options)
    } else {
      api.reload('1ecd578d', component.options)
    }
    module.hot.accept("./followRecordList.vue?vue&type=template&id=1ecd578d&scoped=true&", function () {
      api.rerender('1ecd578d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/bigCustomer/followRecord/followRecordList.vue"
export default component.exports